import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BUSINESS_TYPES = [
  "Tienda / Retail",
  "Servicios profesionales",
  "Gastronomía",
  "Taller / Manufactura",
  "Freelance / Independiente",
  "Otro",
];

export const WaitlistForm = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [businessType, setBusinessType] = useState(BUSINESS_TYPES[0]);
  const [status, setStatus] = useState("idle");

  const ids = compact
    ? { input: "hero-waitlist-input", submit: "hero-waitlist-submit", success: "hero-waitlist-success" }
    : { input: "waitlist-email-input", select: "waitlist-business-select", submit: "waitlist-submit-button", success: "waitlist-success-message" };

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Ingresa un correo electrónico válido");
      return;
    }
    setStatus("loading");
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email, business_type: businessType });
      setStatus("success");
      toast.success(data.message || "¡Estás dentro de la lista VIP!");
    } catch (err) {
      setStatus("idle");
      toast.error(err?.response?.data?.detail || "Algo salió mal, inténtalo de nuevo.");
    }
  };

  if (status === "success") {
    return (
      <div
        data-testid={ids.success}
        className="flex items-center gap-3 rounded-2xl border border-emerald-500/30 bg-emerald-500/10 px-5 py-4"
      >
        <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-400" />
        <p className="text-sm text-emerald-200">
          ¡Listo! Te avisaremos cuando se abra tu cupo de acceso anticipado.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={compact ? "flex flex-col gap-3 sm:flex-row" : "flex flex-col gap-3"}>
      <input
        data-testid={ids.input}
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="tu@correo.com"
        className="h-12 flex-1 rounded-xl border border-white/10 bg-white/5 px-4 text-sm text-slate-100 placeholder:text-slate-500 outline-none transition-colors duration-300 focus:border-emerald-500/60 focus:bg-white/10"
      />
      {!compact && (
        <select
          data-testid={ids.select}
          value={businessType}
          onChange={(e) => setBusinessType(e.target.value)}
          className="h-12 rounded-xl border border-white/10 bg-white/5 px-4 text-sm text-slate-100 outline-none transition-colors duration-300 focus:border-emerald-500/60 [&>option]:bg-[#131316]"
        >
          {BUSINESS_TYPES.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      )}
      <button
        data-testid={ids.submit}
        type="submit"
        disabled={status === "loading"}
        className="group inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 px-6 text-sm font-semibold text-[#0A0A0C] transition-transform duration-300 hover:scale-[1.03] active:scale-[0.98] disabled:opacity-60"
      >
        {status === "loading" ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <>
            Unirme a la lista
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </>
        )}
      </button>
    </form>
  );
};
